var _path, _path2, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConditionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63255 14.3358L7.5 12.3333H9.63255H11.5L9.63255 14.3358Z",
    fill: "#201CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63255 14.3358L9.08949 14.9141L9.66982 15.4591L10.2127 14.8769L9.63255 14.3358ZM7.5 12.3333V11.54C7.17458 11.54 6.88216 11.7387 6.76237 12.0413C6.64258 12.3439 6.71972 12.6889 6.95694 12.9117L7.5 12.3333ZM11.5 12.3333L12.0802 12.8744C12.2956 12.6434 12.3535 12.3067 12.2275 12.017C12.1016 11.7274 11.8158 11.54 11.5 11.54V12.3333ZM10.4259 1C10.4259 0.561854 10.0707 0.206667 9.63255 0.206667C9.19441 0.206667 8.83922 0.561854 8.83922 1H10.4259ZM0.905885 9.5C0.905885 9.93815 1.26107 10.2933 1.69922 10.2933C2.13736 10.2933 2.49255 9.93815 2.49255 9.5H0.905885ZM10.1756 13.7575L8.04306 11.755L6.95694 12.9117L9.08949 14.9141L10.1756 13.7575ZM7.5 13.1267H9.63255V11.54H7.5V13.1267ZM9.63255 13.1267H11.5V11.54H9.63255V13.1267ZM10.9198 11.7923L9.05236 13.7947L10.2127 14.8769L12.0802 12.8744L10.9198 11.7923ZM8.83922 1V6.1H10.4259V1H8.83922ZM8.83922 6.1V12.3333H10.4259V6.1H8.83922ZM8.83922 12.3333V14.3358H10.4259V12.3333H8.83922ZM9.63255 5.30667H2.83255V6.89333H9.63255V5.30667ZM0.905885 7.23333V9.5H2.49255V7.23333H0.905885ZM2.83255 5.30667C1.76848 5.30667 0.905885 6.16926 0.905885 7.23333H2.49255C2.49255 7.04556 2.64478 6.89333 2.83255 6.89333V5.30667Z",
    fill: "#201CE0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 9.5,
    r: 1.5,
    fill: "#201CE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2695 2V6.53333",
    stroke: "#201CE0",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5352 4.26562L13.0018 4.26562",
    stroke: "#201CE0",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionIcon);
export default __webpack_public_path__ + "static/media/condition-icon.a9552230688b4f9c838469e34c67fdc8.svg";
export { ForwardRef as ReactComponent };